"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const luxon_1 = require("luxon");
const lodash_1 = require("lodash");
const Text_1 = require("@amzn/atoz-web/Text");
const View_1 = require("@amzn/atoz-web/View");
const DetailedRadio_1 = require("@amzn/atoz-web/DetailedRadio");
const MessageBanner_1 = require("@amzn/atoz-web/MessageBanner");
const Hr_1 = require("@amzn/atoz-web/Hr");
const icons_1 = require("@amzn/stencil-react-components/icons");
const components_1 = require("../../../../components");
const context_1 = require("../../context");
const useSelectPunch_1 = __importDefault(require("./hooks/useSelectPunch"));
const SelectPunchTypes_1 = require("./SelectPunchTypes");
const PunchWorkflowTypes_1 = require("../../PunchWorkflowTypes");
const PunchModalTypes_1 = require("../../../../components/PunchModal/PunchModalTypes");
const logger_1 = require("../../../../logger");
const contexts_1 = require("../../../../contexts");
const consts_1 = require("../../../../consts");
const utils_1 = require("../../../../utils");
const SelectPunch = () => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { clientName } = (0, contexts_1.useTaaConfigsContext)();
    const dimensions = {
        ClientName: clientName,
        ClientType: logger_1.ClientType.WEB,
        usageLocation: consts_1.featureNames.PUNCH_WORKFLOW_FEATURE
    };
    const { action, selectedPunchTime, editPunchLockoutStatus, setIsCurrentStepValid, setSelectedPunchTime } = (0, context_1.usePunchWorkflowContext)();
    const { localizedSelectedDate, eligiblePunches, ineligiblePunches, isLoading } = (0, useSelectPunch_1.default)();
    (0, react_1.useEffect)(() => {
        utils_1.BIAnalytics.arriveSelectPunchInPW();
    }, []);
    (0, logger_1.useComponentLoadedMetrics)({
        metricNames: {
            countMetricName: logger_1.METRICS.PUNCH_WORKFLOW_SELECT_PUNCH_STEP_RENDERED.COUNT
        },
        isComponentLoaded: !isLoading
    });
    const renderBanner = (type) => {
        if (isLoading)
            return null;
        let bannerText;
        let messageBannerProps;
        switch (type) {
            case SelectPunchTypes_1.BannerType.EditIneligible: {
                bannerText = t('time_and_attendance_PunchWorkflow_SelectPunchStep_Banner_EditIneligible');
                messageBannerProps = {
                    dataTestId: SelectPunchTypes_1.PUNCHWF_SELECTPUNCH_DATA_TEST_IDS.BANNER_EDIT_INELIGIBLE
                };
                break;
            }
            case SelectPunchTypes_1.BannerType.DeleteIneligible: {
                bannerText = t('time_and_attendance_PunchWorkflow_SelectPunchStep_Banner_DeleteIneligible');
                messageBannerProps = {
                    dataTestId: SelectPunchTypes_1.PUNCHWF_SELECTPUNCH_DATA_TEST_IDS.BANNER_DELETE_INELIGIBLE
                };
                break;
            }
            case SelectPunchTypes_1.BannerType.ApproachingLimit: {
                bannerText = t('time_and_attendance_PunchModal_PunchEditLockout_Warning');
                messageBannerProps = {
                    type: MessageBanner_1.MessageBannerType.Warning,
                    icon: react_1.default.createElement(icons_1.IconAlertTriangleFill, { size: 16, title: "Warning icon" }),
                    dataTestId: SelectPunchTypes_1.PUNCHWF_SELECTPUNCH_DATA_TEST_IDS.BANNER_APPROACHING_LIMIT
                };
                break;
            }
            case SelectPunchTypes_1.BannerType.Blocked: {
                bannerText = t('time_and_attendance_PunchModal_PunchEditLockout_LockedOut');
                messageBannerProps = {
                    type: MessageBanner_1.MessageBannerType.Error,
                    icon: react_1.default.createElement(icons_1.IconAlertCircleFill, { size: 16, title: "Error icon" }),
                    dataTestId: SelectPunchTypes_1.PUNCHWF_SELECTPUNCH_DATA_TEST_IDS.BANNER_BLOCKED
                };
                logger_1.logger.emitCountMetric({
                    metricName: logger_1.METRICS.PUNCH_EDIT_LIMIT_LOCKOUT.COUNT,
                    dimensions
                });
                break;
            }
            default:
                return null;
        }
        return react_1.default.createElement(MessageBanner_1.MessageBanner, Object.assign({}, messageBannerProps), bannerText);
    };
    const renderRadioBox = (punch, disabled = false) => {
        const { punchId, punchDateTime: { timestamp }, punchType } = punch;
        const checked = (selectedPunchTime === null || selectedPunchTime === void 0 ? void 0 : selectedPunchTime.punchId) === punchId;
        const timestampAsDateTime = luxon_1.DateTime.fromISO(timestamp);
        const selectHandler = () => {
            utils_1.BIAnalytics.selectPunchInPW();
            const punchCopy = (0, lodash_1.cloneDeep)(punch);
            delete punchCopy.punchType;
            setSelectedPunchTime(punchCopy);
            setIsCurrentStepValid(true);
        };
        return (react_1.default.createElement(View_1.View, { margin: { top: 'S200', bottom: 'S200' }, key: punchId, dataTestId: disabled
                ? SelectPunchTypes_1.PUNCHWF_SELECTPUNCH_DATA_TEST_IDS.PUNCH_RADIO_BOX_INELIGIBLE
                : SelectPunchTypes_1.PUNCHWF_SELECTPUNCH_DATA_TEST_IDS.PUNCH_RADIO_BOX_ELIGIBLE },
            react_1.default.createElement(DetailedRadio_1.DetailedRadio, { checked: checked, name: punchId, value: punchId, titleText: t(`time_and_attendance_PunchWorkflow_SelectPunchStep_${punchType}`, { time: timestampAsDateTime.toLocaleString(luxon_1.DateTime.TIME_SIMPLE) }), disabled: disabled, onClick: selectHandler, dataTestId: checked
                    ? SelectPunchTypes_1.PUNCHWF_SELECTPUNCH_DATA_TEST_IDS.PUNCH_RADIO_CHECKED
                    : SelectPunchTypes_1.PUNCHWF_SELECTPUNCH_DATA_TEST_IDS.PUNCH_RADIO_UNCHECKED })));
    };
    return (react_1.default.createElement(View_1.View, { dataTestId: SelectPunchTypes_1.PUNCHWF_SELECTPUNCH_DATA_TEST_IDS.SELECT_PUNCH },
        react_1.default.createElement(View_1.View, null,
            react_1.default.createElement(Text_1.Text, null, localizedSelectedDate)),
        react_1.default.createElement(View_1.View, { margin: { top: 'S400' } },
            react_1.default.createElement(components_1.SpinnerOverlay, { isLoading: isLoading },
                ineligiblePunches.length > 0 && (react_1.default.createElement(View_1.View, { dataTestId: SelectPunchTypes_1.PUNCHWF_SELECTPUNCH_DATA_TEST_IDS.SECTION_INELIGIBLE },
                    react_1.default.createElement(Text_1.H2, { fontSize: "T400", fontWeight: 700 }, t('time_and_attendance_PunchWorkflow_SelectPunchStep_IneligiblePunches')),
                    react_1.default.createElement(View_1.View, { margin: { top: 'S200', bottom: 'S200' } }, renderBanner(action === PunchWorkflowTypes_1.PUNCH_WORKFLOW_ACTIONS.DELETE
                        ? SelectPunchTypes_1.BannerType.DeleteIneligible
                        : editPunchLockoutStatus === PunchModalTypes_1.LockoutStatusType.LOCKED_OUT
                            ? SelectPunchTypes_1.BannerType.Blocked
                            : SelectPunchTypes_1.BannerType.EditIneligible)),
                    ineligiblePunches.map((punch) => renderRadioBox(punch, true)))),
                eligiblePunches.length > 0 && (react_1.default.createElement(View_1.View, { margin: { top: 'S400' }, dataTestId: SelectPunchTypes_1.PUNCHWF_SELECTPUNCH_DATA_TEST_IDS.SECTION_ELIGIBLE },
                    react_1.default.createElement(Text_1.H2, { fontSize: "T400", fontWeight: 700 }, action === PunchWorkflowTypes_1.PUNCH_WORKFLOW_ACTIONS.EDIT
                        ? t('time_and_attendance_PunchWorkflow_SelectPunchStep_EligiblePunchesToEdit')
                        : t('time_and_attendance_PunchWorkflow_SelectPunchStep_EligiblePunchesToDelete')),
                    action === PunchWorkflowTypes_1.PUNCH_WORKFLOW_ACTIONS.EDIT &&
                        editPunchLockoutStatus === PunchModalTypes_1.LockoutStatusType.WARNING && (react_1.default.createElement(View_1.View, { margin: { top: 'S200', bottom: 'S200' } }, renderBanner(SelectPunchTypes_1.BannerType.ApproachingLimit))),
                    eligiblePunches.map((punch) => renderRadioBox(punch)))))),
        react_1.default.createElement(View_1.View, { margin: { top: 'S400', bottom: 'S200' } },
            react_1.default.createElement(Hr_1.Hr, null))));
};
exports.default = SelectPunch;
